import React from "react";

export default function Loader() {
  return (
    <div
      className={`w-screen h-svh flex justify-center items-center fixed backdrop-blur-sm top-0 right-0 z-50`}
    >
      <span className="loading loading-infinity w-28 text-myGreen34A"></span>
    </div>
  );
}
